export default {
	notification_health: 'Stav oznámení',
	notification_health_summary: 'Souhrn',
	notification_health_loading: 'Kontrola stavu oznámení...',
	notification_health_refresh: 'Obnovit',
	notification_health_fix: 'Co dělat',
	notification_health_unavailable: 'Nepodařilo se načíst stav oznámení',
	notification_health_healthy: 'V pořádku',
	notification_health_blocked: 'Blokováno',
	notification_health_degraded: 'Vyžaduje pozornost',
	notification_health_no_app_user: 'Bez přihlášení do aplikace',
	notification_health_unknown: 'Neznámé',
	notification_health_app_version: 'Verze aplikace',
	notification_health_last_delivery: 'Poslední doručení',
	notification_health_time_just_now: 'právě teď',
	notification_health_time_minutes: 'před {count} min.',
	notification_health_time_hours: 'před {count} hod.',
	notification_health_time_days: 'před {count} dny',
	notification_health_time_unknown: 'neznámé',
	notification_health_summary_healthy: 'Oznámení by měla fungovat',
	notification_health_summary_no_app_user: 'Uklízeč se nepřihlásil do mobilní aplikace',
	notification_health_summary_blocked_no_token: 'Chybí push token — uklízeč musí otevřít aplikaci a přihlásit se',
	notification_health_summary_blocked_off: 'Oznámení jsou v aplikaci vypnutá',
	notification_health_check_portal_contact_label: 'Kontakt v portálu existuje',
	notification_health_check_portal_active_label: 'Kontakt je aktivní',
	notification_health_check_portal_rooms_label: 'Přiřazené místnosti',
	notification_health_check_portal_shifts_label: 'Přiřazené směny',
	notification_health_check_app_user_label: 'Přihlášen do mobilní aplikace',
	notification_health_check_push_token_label: 'Push token registrován',
	notification_health_check_notification_mode_label: 'Režim oznámení',
	notification_health_check_time_schedule_label: 'V rámci časového okna oznámení',
	notification_health_check_ios_geo_filter_label: 'Filtr polohy iOS',
	notification_health_check_recent_push_attempt_label: 'Nedávný pokus o push (48 h)',
	notification_health_check_last_push_ignored_label: 'Poslední signál nebyl odeslán',
	notification_health_check_recent_push_delivered_label: 'Nedávné doručení push (48 h)',
	notification_health_detail_portal_contact_found: 'Nalezeno v portálu',
	notification_health_detail_portal_contact_missing: 'Záznam kontaktu nenalezen',
	notification_health_detail_portal_active_active: 'Aktivní',
	notification_health_detail_portal_active_inactive: 'Neaktivní',
	notification_health_detail_portal_rooms_assigned: '{count} místností',
	notification_health_detail_portal_rooms_none: 'Žádné místnosti nepřiřazeny',
	notification_health_detail_portal_shifts_assigned: '{count} směn',
	notification_health_detail_portal_shifts_none: 'Žádné směny nepřiřazeny',
	notification_health_detail_app_user_logged_in: 'Verze aplikace {version}, poslední synchronizace {lastSync}',
	notification_health_detail_app_user_never: 'Nikdy se nepřihlásil',
	notification_health_detail_push_token_present: 'FCM token přítomen',
	notification_health_detail_push_token_empty: 'Token je prázdný',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Aktuální čas je v rámci rozvrhu',
	notification_health_detail_time_schedule_outside: 'Aktuální čas je mimo nastavený rozvrh',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Žádné pokusy o push za posledních 48 hodin',
	notification_health_detail_last_push_ignored: 'Poslední požadavek push byl ignorován (servik není nakonfigurován pro pracovní oblast)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Žádná úspěšná doručení za posledních 48 hodin',
	notification_health_fix_portal_contact: 'Vytvořte tohoto uklízeče v panelu Uživatelé',
	notification_health_fix_portal_active: 'Zapněte přepínač Aktivní pro tohoto uklízeče',
	notification_health_fix_portal_rooms: 'Přiřaďte alespoň jednu místnost tomuto uklízeči',
	notification_health_fix_portal_shifts: 'Přiřaďte alespoň jednu směnu',
	notification_health_fix_app_user: 'Uklízeč musí nainstalovat aplikaci a přihlásit se tímto telefonním číslem',
	notification_health_fix_push_token: 'Požádejte uklízeče, aby otevřel aplikaci, povolil oznámení v nastavení iOS a znovu se přihlásil',
	notification_health_fix_notification_mode: 'Změňte režim oznámení z Vypnuto na Vždy v aplikaci',
	notification_health_fix_time_schedule: 'Počkejte do naplánovaného okna nebo změňte režim na Vždy',
	notification_health_fix_ios_geo_filter: 'Uklízeč je mimo zónu oznámení — požádejte ho, aby otevřel aplikaci na místě',
	notification_health_fix_last_push_ignored: 'Zkontrolujte konfiguraci servik pracovní oblasti pro místnost, která spustila signál',
	notification_health_fix_recent_push_delivered_filters: 'Zkontrolujte filtry oznámení nebo nastavení zařízení',
	notification_health_fix_recent_push_delivered_token: 'Nejprve zaregistrujte push token',
	notification_health_mode_on: 'Vždy',
	notification_health_mode_off: 'Vypnuto',
	notification_health_mode_time: 'Podle času',
	notification_health_mode_location: 'Podle polohy',
	notification_health_filter_on: 'Zapnuto',
	notification_health_filter_off: 'Vypnuto',
};
